(function () {
  'use strict';

  function mount(panel, environment) {
    if (panel.hnsController) return panel.hnsController;
    var win = environment || window;
    var doc = panel.ownerDocument;
    var header = panel.closest('#hnh');
    var trigger = header && header.querySelector('[data-hns-trigger]');
    if (!trigger) return null;
    var input = panel.querySelector('[data-hns-input]');
    var form = panel.querySelector('[data-hns-form]');
    var results = panel.querySelector('[data-hns-results]');
    var status = panel.querySelector('[data-hns-status]');
    var live = panel.querySelector('[data-hns-live]');
    var initial = panel.querySelector('[data-hns-initial]');
    var clear = panel.querySelector('[data-hns-clear]');
    var closeButton = panel.querySelector('[data-hns-close]');
    var viewAll = panel.querySelector('[data-hns-view-all]');
    var backdrop = header.querySelector('[data-hns-backdrop]');
    if (!input || !form || !results || !status || !viewAll || !backdrop) return null;
    var labels;
    try { labels = JSON.parse(panel.dataset.labels); } catch (_) { return null; }
    var opened = false;
    var hoverOnly = false;
    var composing = false;
    var sequence = 0;
    var debounce;
    var hoverTimer;
    var closeTimer;
    var timeout;
    var request;
    var options = [];
    var active = -1;
    var listeners = [];
    var cache = new Map();
    var familyIndexPromise;
    var currency = win.Shopify && win.Shopify.currency && win.Shopify.currency.active || panel.dataset.currency || 'USD';
    var locale = panel.dataset.locale || doc.documentElement.lang || 'en';
    var formatter;
    try { formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }); }
    catch (_) { formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); }

    function listen(target, event, callback, settings) {
      target.addEventListener(event, callback, settings);
      listeners.push(function () { target.removeEventListener(event, callback, settings); });
    }
    function text(key, values) {
      return String(labels[key] || '').replace(/\{(\w+)\}/g, function (all, name) {
        return values && values[name] != null ? String(values[name]) : all;
      });
    }
    function element(tag, className, value) {
      var node = doc.createElement(tag);
      if (className) node.className = className;
      if (value != null) node.textContent = value;
      return node;
    }
    function query() { return input.value.trim().slice(0, 200); }
    function safeURL(value, image) {
      if (!value || typeof value !== 'string') return null;
      try {
        var url = new URL(value, win.location.href);
        if (!/^https?:$/.test(url.protocol) || !image && url.origin !== win.location.origin) return null;
        if (!image) {
          var preview = new URL(win.location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
        }
        return url;
      } catch (_) { return null; }
    }
    function searchURL(value) {
      var url = safeURL(panel.dataset.searchUrl || form.action);
      url.searchParams.set('q', value);
      url.searchParams.set('options[prefix]', 'last');
      return url.href;
    }
    function setActive(index) {
      active = index;
      options.forEach(function (option, i) { option.setAttribute('aria-selected', String(i === index)); });
      if (index >= 0 && options[index]) {
        input.setAttribute('aria-activedescendant', options[index].id);
        options[index].scrollIntoView({ block: 'nearest' });
      } else input.removeAttribute('aria-activedescendant');
    }
    function invalidate() {
      sequence += 1;
      win.clearTimeout(debounce);
      win.clearTimeout(timeout);
      if (request) request.abort();
      request = null;
      return sequence;
    }
    function busy(value) {
      panel.setAttribute('aria-busy', String(value));
      panel.dataset.loading = String(value);
    }
    function announce(value) { if (live) live.textContent = value; }
    function resetResults() {
      setActive(-1);
      options = [];
      results.replaceChildren();
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }
    function position() {
      if (!opened) return;
      var bottom = Math.max(0, header.getBoundingClientRect().bottom);
      var viewportBottom = win.visualViewport ? win.visualViewport.offsetTop + win.visualViewport.height : win.innerHeight;
      header.style.setProperty('--hns-top', bottom + 'px');
      header.style.setProperty('--hns-space', Math.max(180, viewportBottom - bottom - 16) + 'px');
    }
    function close(restoreFocus) {
      var wasOpened = opened;
      opened = false;
      hoverOnly = false;
      invalidate();
      win.clearTimeout(hoverTimer);
      win.clearTimeout(closeTimer);
      if (!wasOpened) return;
      busy(false);
      resetResults();
      panel.hidden = true;
      backdrop.hidden = true;
      header.classList.remove('hns-open');
      doc.documentElement.classList.remove('hns-search-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) trigger.focus();
    }
    function showMessage(key, value) {
      status.textContent = text(key, { query: value });
      announce(status.textContent);
    }
    function option(node) {
      node.id = 'hns-option-' + sequence + '-' + options.length;
      node.setAttribute('role', 'option');
      node.setAttribute('aria-selected', 'false');
      node.tabIndex = -1;
      options.push(node);
      return node;
    }
    function group(title) { results.appendChild(element('div', 'hns-group-heading', text(title))); }
    function render(payload, value, run) {
      if (!opened || run !== sequence || value !== query()) return;
      resetResults();
      var data = payload && payload.resources && payload.resources.results;
      if (!data || !Array.isArray(data.products)) throw new Error('Invalid predictive results');
      var products = data.products.slice(0, 6);
      var queries = Array.isArray(data.queries) ? data.queries.slice(0, 3) : [];
      var collections = Array.isArray(data.collections) ? data.collections.slice(0, 2) : [];
      if (products.length) group('products');
      products.forEach(function (product) {
        var url = safeURL(product.url);
        if (!url || typeof product.title !== 'string') return;
        var link = element('a', 'hns-product');
        link.href = url.href;
        link.title = product.title;
        var source = safeURL(product.featured_image && product.featured_image.url || product.image, true);
        if (source) {
          source.searchParams.set('width', '160');
          var image = element('img', 'hns-product-image');
          image.src = source.href;
          image.alt = '';
          image.width = 72;
          image.height = 86;
          image.loading = 'lazy';
          image.decoding = 'async';
          link.appendChild(image);
        } else link.appendChild(element('span', 'hns-product-image hns-product-image--empty'));
        var copy = element('span', 'hns-product-copy');
        copy.appendChild(element('span', 'hns-product-title', product.title));
        var detail = [product.type, product.available === false ? text('soldOut') : ''].filter(Boolean).join(' · ');
        if (detail) copy.appendChild(element('span', 'hns-product-meta', detail));
        var rawPrice = product.price_min != null && product.price_min !== '' ? product.price_min : product.price;
        var price = rawPrice == null || String(rawPrice).trim() === '' ? NaN : Number(rawPrice);
        var maximum = Number(product.price_max);
        var validPrice = Number.isFinite(price) && price >= 0;
        var formatted = validPrice ? formatter.format(price) : text('unpriced');
        if (validPrice && maximum > price) formatted = text('from', { price: formatted });
        copy.appendChild(element('span', 'hns-product-price', formatted));
        link.appendChild(copy);
        results.appendChild(option(link));
      });
      if (collections.length) group('collections');
      collections.forEach(function (collection) {
        var url = safeURL(collection.url);
        if (!url || typeof collection.title !== 'string') return;
        var link = element('a', 'hns-suggestion');
        link.href = url.href;
        link.appendChild(element('span', 'hns-suggestion-text', collection.title));
        link.appendChild(element('span', 'hns-suggestion-type', text('collection')));
        results.appendChild(option(link));
      });
      if (queries.length) group('suggestions');
      queries.forEach(function (suggestion) {
        if (typeof suggestion.text !== 'string') return;
        var link = element('a', 'hns-suggestion');
        link.href = searchURL(suggestion.text);
        link.appendChild(element('span', 'hns-suggestion-text', suggestion.text));
        link.appendChild(element('span', 'hns-suggestion-type', '↗'));
        results.appendChild(option(link));
      });
      results.hidden = options.length === 0;
      input.setAttribute('aria-expanded', String(options.length > 0));
      status.textContent = options.length ? text('results', { count: options.length, query: value }) : text('empty', { query: value });
      panel.dataset.state = options.length ? 'results' : 'empty';
      announce(options.length ? text('announced', { count: options.length }) || status.textContent : status.textContent);
      busy(false);
    }
    async function groupPlanumProducts(payload, value) {
      if (!/(?:^|[^0-9])0010(?:[^0-9]|$)/.test(value)) return payload;
      var global = doc.querySelector('[data-hn-family-global]');
      var url = global && safeURL(global.dataset.indexUrl);
      if (!url) return payload;
      try {
        if (!familyIndexPromise) {
          var mappingController = new win.AbortController();
          var mappingTimeout = win.setTimeout(function () { mappingController.abort(); }, 5000);
          familyIndexPromise = win.fetch(url.href, { credentials: 'same-origin', signal: mappingController.signal }).then(function (response) {
            if (!response.ok) throw new Error('Family data unavailable');
            return response.json();
          }).catch(function (error) { familyIndexPromise = null; throw error; }).finally(function () { win.clearTimeout(mappingTimeout); });
        }
        var index = await familyIndexPromise;
        var source = payload && payload.resources && payload.resources.results;
        if (!source || !Array.isArray(source.products)) return payload;
        var seen = new Set();
        var products = [];
        source.products.forEach(function (product) {
          var entry = index.products[String(product.id)] || index.products[product.handle];
          if (!entry || entry.familyId !== 'f4a' || !entry.openingType) { products.push(product); return; }
          if (seen.has(entry.openingType)) return;
          seen.add(entry.openingType);
          var title = index.families.f4a.title + ' — ' + entry.typeLabel;
          var finish = String(product.title || '').split('|')[2];
          products.push(Object.assign({}, product, { title: title, type: finish ? finish.trim() : product.type }));
        });
        return Object.assign({}, payload, { resources: Object.assign({}, payload.resources, { results: Object.assign({}, source, { products: products }) }) });
      } catch (_) { return payload; }
    }
    async function fetchResults(value, run) {
      if (!opened || run !== sequence) return;
      var cached = cache.get(value.toLowerCase());
      if (cached && Date.now() - cached.time < 30000) { render(cached.payload, value, run); return; }
      var controller = new win.AbortController();
      request = controller;
      var timedOut = false;
      timeout = win.setTimeout(function () { timedOut = true; controller.abort(); }, 7000);
      try {
        var url = safeURL(panel.dataset.suggestUrl || panel.dataset.searchUrl + '/suggest');
        url.pathname = url.pathname.replace(/\/$/, '').replace(/\.json$/, '') + '.json';
        url.searchParams.set('q', value);
        url.searchParams.set('resources[type]', 'product,query,collection');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        var response = await win.fetch(url.href, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Predictive search HTTP ' + response.status);
        var payload = await response.json();
        payload = await groupPlanumProducts(payload, value);
        if (!opened || run !== sequence || value !== query()) return;
        render(payload, value, run);
        if (cache.size >= 15) cache.delete(cache.keys().next().value);
        cache.set(value.toLowerCase(), { time: Date.now(), payload: payload });
      } catch (error) {
        if (!opened || run !== sequence || value !== query() || controller.signal.aborted && !timedOut) return;
        resetResults();
        busy(false);
        panel.dataset.state = 'error';
        showMessage('error', value);
      } finally {
        if (run === sequence) { win.clearTimeout(timeout); request = null; }
      }
    }
    function change(immediate) {
      var run = invalidate();
      var value = query();
      resetResults();
      if (clear) clear.hidden = !input.value;
      initial.hidden = !!value;
      viewAll.hidden = !value;
      if (value) {
        viewAll.href = searchURL(value);
        var viewLabel = viewAll.querySelector('span');
        if (viewLabel) viewLabel.textContent = text('viewAll', { query: value });
        else viewAll.textContent = text('viewAll', { query: value });
      }
      if (value.length < 2) {
        busy(false);
        panel.dataset.state = 'initial';
        showMessage(value ? 'minimum' : 'initial', value);
        return;
      }
      busy(true);
      panel.dataset.state = 'loading';
      showMessage('loading', value);
      debounce = win.setTimeout(function () { fetchResults(value, run); }, immediate ? 0 : 180);
    }
    function open(focusInput, byHover) {
      win.clearTimeout(closeTimer);
      if (!opened) {
        var drawer = header.querySelector('#hnh-drawer');
        if (drawer && drawer.classList.contains('open')) header.querySelector('#hnh-drawer-close').click();
        opened = true;
        hoverOnly = !!byHover;
        panel.hidden = false;
        backdrop.hidden = false;
        header.classList.add('hns-open');
        if (!byHover) doc.documentElement.classList.add('hns-search-open');
        trigger.setAttribute('aria-expanded', 'true');
        position();
        change(true);
      }
      if (focusInput) {
        hoverOnly = false;
        doc.documentElement.classList.add('hns-search-open');
        input.focus({ preventScroll: true });
      }
    }
    listen(trigger, 'click', function (event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (opened && !hoverOnly) close(true); else open(true, false);
    });
    listen(trigger, 'pointerenter', function (event) {
      if (event.pointerType !== 'mouse' || !win.matchMedia('(hover: hover) and (min-width: 1081px)').matches) return;
      win.clearTimeout(closeTimer);
      hoverTimer = win.setTimeout(function () { open(false, true); }, 180);
    });
    listen(trigger, 'pointerleave', function (event) {
      win.clearTimeout(hoverTimer);
      if (hoverOnly && !panel.contains(event.relatedTarget)) closeTimer = win.setTimeout(function () { close(false); }, 250);
    });
    listen(panel, 'pointerenter', function () { win.clearTimeout(closeTimer); });
    listen(panel, 'pointerleave', function (event) {
      if (hoverOnly && !trigger.contains(event.relatedTarget)) closeTimer = win.setTimeout(function () { close(false); }, 250);
    });
    listen(panel, 'pointerdown', function () {
      hoverOnly = false;
      doc.documentElement.classList.add('hns-search-open');
    });
    listen(input, 'focus', function () { if (opened) { hoverOnly = false; doc.documentElement.classList.add('hns-search-open'); } });
    listen(input, 'compositionstart', function () { composing = true; invalidate(); resetResults(); busy(false); });
    listen(input, 'compositionend', function () { composing = false; change(false); });
    listen(input, 'input', function () { if (!composing) change(false); });
    listen(input, 'keydown', function (event) {
      if (event.isComposing || composing) return;
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && options.length) {
        event.preventDefault();
        setActive(event.key === 'ArrowDown' ? (active + 1) % options.length : active < 0 ? options.length - 1 : (active - 1 + options.length) % options.length);
      } else if (event.key === 'Enter' && active >= 0 && options[active]) {
        event.preventDefault();
        options[active].click();
      }
    });
    listen(form, 'submit', function (event) {
      if (!query()) { event.preventDefault(); input.focus(); }
    });
    listen(panel, 'click', function (event) {
      var example = event.target.closest('[data-hns-query]');
      if (example) { input.value = example.dataset.hnsQuery; input.focus(); change(true); }
    });
    listen(results, 'pointerover', function (event) {
      var found = event.target.closest('[role="option"]');
      if (found && event.pointerType !== 'touch') setActive(options.indexOf(found));
    });
    if (clear) listen(clear, 'click', function () { input.value = ''; input.focus(); change(true); });
    if (closeButton) listen(closeButton, 'click', function () { close(true); });
    listen(backdrop, 'pointerdown', function () { close(false); });
    listen(doc, 'keydown', function (event) {
      if (opened && event.key === 'Escape' && !event.isComposing && !composing) { event.preventDefault(); close(true); }
    });
    listen(doc, 'focusin', function (event) {
      if (opened && !panel.contains(event.target) && !trigger.contains(event.target)) close(false);
    });
    listen(doc, 'pointerdown', function (event) {
      if (opened && !panel.contains(event.target) && !trigger.contains(event.target)) close(false);
    });
    listen(win, 'resize', position, { passive: true });
    if (win.visualViewport) listen(win.visualViewport, 'resize', position, { passive: true });
    listen(win, 'pagehide', function () { close(false); });
    panel.hnsController = {
      close: close,
      destroy: function () { close(false); listeners.forEach(function (remove) { remove(); }); cache.clear(); delete panel.hnsController; }
    };
    return panel.hnsController;
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = mount;
  if (typeof document !== 'undefined') {
    function start() { document.querySelectorAll('[data-hns-root]').forEach(function (panel) { mount(panel); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
    document.addEventListener('shopify:section:load', start);
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-hns-root]').forEach(function (panel) { if (panel.hnsController) panel.hnsController.destroy(); });
    });
  }
})();
